// src/components/Profile/MyProfile.jsx
import React, { useState } from 'react';
import { updateProfile } from '../../api/userApi';
import '../../Style/MyProfile.css';

const MyProfile = ({ user, onUpdate }) => {
  const [formData, setFormData] = useState({
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    birthDate: user.birthDate || '', // Change birthday -> birthDate
    gender: user.gender || 'MAN', // Enums are usually uppercase in Java
    location: user.location || '', // Have not yet added in backend
    vanityUrl: user.vanityUrl || '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedUser = await updateProfile(formData);
      // Success! You might want to update the global user state here
      console.log('Profile updated!', updatedUser);
      alert('Profile saved successfully!');
      if (onUpdate) onUpdate(updatedUser);
    } catch (err) {
      console.error('Failed to update profile', err);
      const data = err.response?.data;
      const message = typeof data === 'string' ? data : data?.message || 'Error saving profile.';
      alert(message);
    }
  };

  return (
    <div className="app-container">
      <div className="profile-settings-container">
        <h2>My Profile</h2>
        <form onSubmit={handleSubmit} className="profile-form">
          <div className="form-row">
            <label>First Name</label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              maxLength={50}
            />
          </div>

          <div className="form-row">
            <label>Last Name</label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              maxLength={50}
            />
          </div>

          <div className="form-row">
            <label>Birthday</label>
            <input
              type="date"
              name="birthDate"
              value={formData.birthDate}
              onChange={handleChange}
            />
          </div>

          <div className="form-row">
            <label>Gender</label>
            <select name="gender" value={formData.gender} onChange={handleChange}>
              <option value="MAN">Man</option>
              <option value="WOMAN">Woman</option>
              <option value="NON_BINARY">Non-binary</option>
              <option value="PREFER_NOT_TO_SAY">Prefer not to say</option>
            </select>
          </div>

          {/* <div className="form-row">
          <label>Location</label>
          <input
            name="location"
            value={formData.location}
            placeholder="e.g. Toronto, ON"
            onChange={handleChange}
          />
        </div> */}

          {/* <div className="form-row">
          <label>Vanity URL</label>
          <div className="url-input-group">
            <span>myapp.com/athletes/</span>
            <input name="vanityUrl" value={formData.vanityUrl} onChange={handleChange} />
          </div>
        </div> */}

          <button type="submit" className="save-btn">
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
};

export default MyProfile;
